import {Component, Input, OnInit} from '@angular/core';
import {SelectableLab} from '../carrier/selectable-lab';
import {MasterDataService} from '../masterdata/masterdata.service';
import {LabMDM} from '../masterdata/models/lab';
import {Process} from '../masterdata/models/process';
import {PlateContentDefinition, Workfile} from '../masterdata/models/workfile';
import {MessagesService} from '../messages/messages.service';
import {ErrorHandler} from '../utils/error-handler';
import {MdmWorkfilesConfigService} from './mdm-workfiles-config.service';
import {DatePipe} from '@angular/common';
import {Calculation} from '../masterdata/models/calculation';
import {WorkfileDefinitionHeader} from '../masterdata/models/workFileDefinitionHeader';


import {OperetionHistoryDTO} from '../masterdata/models/operationHistory';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-mdm-workfiles-config',
  templateUrl: './mdm-workfiles-config.component.html',
  styleUrls: ['./mdm-workfiles-config.component.css']
})
export class MdmWorkfilesConfigComponent implements OnInit {

  @Input() masterLists: Workfile[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;

  validationFlag: boolean = false;
  masterList: Workfile;
  selectedLabName: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  selectedLabId: string;
  isNewMasterList: boolean;
  displayMasterListDialog: boolean = false;
  selectedMasterList: Workfile;
  fileFormatOptions:any[];
  machineTypeOptions:any[];
  processNameOptions:Process[];
  stepNameOptions:SelectItem[];
  blocked:boolean=false;
  selectedLab: LabMDM;
  selectedFileFormat:any;
  selectedMachineType:any;
  selectedProcess:Process;
  selectedProcessName:string;
  selectedProcessStep:string;
  fileName:string;
  latestDate:string;
  latestTime:string;
  formatString:string;
  userConfigFlag : boolean = false;
  tabIndex : number=0;
  dataSources : any[];
  sourcePlatedataSources : any[];
  targetPlatedataSources : any[];
  dataSourceForCalc : any[];
  operandSources : any[];
  operatorOptions : any[];
  selectedOperator : any;
  operandResult : any[];
  firstOperand : any;
  secondOperand : any;
  sourceName : any;
  calButtonFlag : boolean = false;
  calculationList : Calculation[]=[];
  calculations : any[]=[];
  calculationObject : Calculation;
  sourceNotValidFlag : boolean = false;
  nonNumericSources = new Map<string, string>();
  numericSources = new Map<string, string>();
  numericOperator = new Map<string, string>();
  errorList : any[]=[];
  selectedHeaderValue: string = 'yes';
  selectedFileContentDefinition = 'tubes'
  tableDefinitionHeaders :WorkfileDefinitionHeader[]=[];
  groupedSource :any[];
  listOfFileDefError :any[];
  hoverDrag : string = 'Drag to change the column order';
  columnHeaderForDefinition:any[];
  sourcePlateDef :any[]=[];
  targetPlateDef  : any[]=[];
  groupForSampleLibrary :any[];
  mapOfSourceNamewithCategory =  new Map();
  validationMap =  new Map();
  continueWithMachineOptions : boolean = true;
  workFileProcessStepMap = new Map<string, string>();
  sourcePlatePrefix  = false;
  targetPlatePrefix  = false;
  reduceToOneRow  = false;
  mapOfStepDisplayNameAndProcessStepEntity = new Map();

  reagent1Name: string;
  reagent2Name: string;
  reagent3Name: string;
  reagent1Volume: number;
  reagent2Volume: number;
  reagent3Volume: number;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private _mdmWorkfileConfigService: MdmWorkfilesConfigService, private _datePipe: DatePipe) { }

  ngOnInit() {

    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedLabName = JSON.parse(localStorage.getItem('lab')).lab.name;

    var labObj = new LabMDM();
    labObj._id = this.selectedLabId;
    labObj.name = this.selectedLabName;
    this.selectedLab=labObj;

    this.puid = localStorage.getItem('PUID');
    this.fileFormatOptions = [
      {label:'CSV (comma delimited)', name:'CSV (comma delimited)'},
      {label:'CSV (semicolon delimited)', name:'CSV (semicolon delimited)'},
      {label:'TXT (tab delimited)', name:'TXT (tab delimited)'}
    ];

    this.machineTypeOptions = [
      {label:'FLX', name:'FLX'},
      {label:'FA', name:'FA'},
      {label:'qPCR', name:'qPCR'}
    ];
    this.operatorOptions = [
      {label:'CONCAT', value:'CONCAT'},
      {label:'MAX', value:'MAX'},
      {label:'MIN', value:'MIN'},
      {label:'PRODUCT', value:'PRODUCT'},
      {label:'QUOTIENT', value:'QUOTIENT'},
      {label:'SUBSTRACT', value:'SUBSTRACT'},
      {label:'SUM', value:'SUM'}

    ];

    this.numericOperator.set('MIN','MIN');
    this.numericOperator.set('MAX','MAX');
    this.numericOperator.set('SUM','SUM');
    this.numericOperator.set('PRODUCT','PRODUCT');
    this.numericOperator.set('QUOTIENT','QUOTIENT');
    this.numericOperator.set('SUBSTRACT','SUBSTRACT');


    this.numericSources.set('sample_concentration','sample_concentration');
    this.numericSources.set('available_volume','available_volume');
    this.numericSources.set('available_amount','available_amount');
    this.numericSources.set('used_amount','used_amount');
    this.numericSources.set('library_concentration','library_concentration');
    this.numericSources.set('size','size');
    this.numericSources.set('molarity','molarity');

    this.nonNumericSources.set('sample_barcode','sample_barcode');
    this.nonNumericSources.set('sample_name','sample_name');
    this.nonNumericSources.set('customer_samplename','customer_samplename');
    this.nonNumericSources.set('library_id','library_id');
    this.nonNumericSources.set('library_barcode','library_barcode');
    this.nonNumericSources.set('library_type','library_type');
    this.nonNumericSources.set('library_tag_name','library_tag_name');
    this.nonNumericSources.set('library_tag_sequence','library_tag_sequence');
    this.nonNumericSources.set('library_tag_plate_barcode','library_tag_plate_barcode');
    this.nonNumericSources.set('library_tag_plate_position','library_tag_plate_position');
    this.nonNumericSources.set('project_name','project_name');

    this.columnHeaderForDefinition = [
      { 'header': '', 'field': '', 'selected': false },
      { 'header': 'Header', 'field': 'header', 'selected': false },
      { 'header': 'Source', 'field': 'source', 'selected': false },
      { 'header': 'Column', 'field': 'column', 'selected': false },
      { 'header': '', 'field': '', 'selected': false }
    ]
    this.initialiseDataSource();

    this.getProcessList();
    this.getPreview();
  }

  initialiseDataSource(){
    this.dataSources=[
      'sample_barcode',
      'sample_name',
      'customer_samplename',
      'sample_concentration',
      'library_concentration',
      'available_volume',
      'library_id',
      'library_barcode',
      'library_type',
      'used_amount',
      'library_tag_name',
      'library_tag_sequence',
      'library_tag_plate_barcode',
      'library_tag_plate_position',
      'project_name',
      'library_target'
    ];
    this.dataSources.sort((a, b) => {
      if (a < b) {
        return -1;
      }else if (a > b) {
        return 1;
      }
      return 0;
      })
    this.dataSourceForCalc=[
      'available_amount',
      'lib_conc_per_base',
      'molarity'
    ];

    this.groupForSampleLibrary = this.dataSources.map(sources => ({ label: sources, value: sources+"#General"}));
  }

  getPreview(){
    var date = new Date();
    this.latestDate = this._datePipe.transform(date, 'yyMMdd');
    this.latestTime = this._datePipe.transform(date, 'HHmmss');
    this.fileName = this.latestDate+"_"+this.latestTime+"_constant substring_Worklist.format";
  }

  addConstSubstringPreview(){

    this.disableMachineOptionType();

    if(this.masterList.constantSubstring && !this.selectedFileFormat){
        this.fileName = this.latestDate+"_"+this.latestTime+"_"+this.masterList.constantSubstring+"_Worklist.format";
    }else if(!this.masterList.constantSubstring && this.selectedFileFormat){
        this.formatString = this.selectedFileFormat.name.substring(0,3);
        this.fileName = this.latestDate+"_"+this.latestTime+"_constant substring_Worklist."+this.formatString.toLocaleLowerCase();
    }else if(this.masterList.constantSubstring && this.selectedFileFormat){
        this.formatString = this.selectedFileFormat.name.substring(0,3);
        this.fileName = this.latestDate+"_"+this.latestTime+"_"+this.masterList.constantSubstring+"_Worklist."+this.formatString.toLocaleLowerCase();
    }else{
          this.fileName = this.latestDate+"_"+this.latestTime+"_constant substring_Worklist.format";
    }
  }



  private disableMachineOptionType() {
    if (this.selectedFileFormat && this.selectedFileFormat.name == "TXT (tab delimited)") {
      this.continueWithMachineOptions = false;
    } else {
      this.selectedMachineType = null;
      this.continueWithMachineOptions = true;
    }
  }

  getProcessList(){
    this.processNameOptions=[];

    this._masterDataService.getProcessData(this.selectedLabId).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.processNameOptions = results.data;
        this.processNameOptions.forEach(type => {
          if (this.masterList && this.masterList.processName && type.name == this.masterList.processName) {
            this.selectedProcessName = this.masterList.processName;
            this.selectedProcess = type;
          }
        })
        if (!this.masterList || !this.masterList.processName || this.selectedProcessName != this.masterList.processName)
          this.selectedProcessName = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
  }


  getProcessStepList(){
    this.stepNameOptions=[];
    let stepList=[];
    let stepFinalList = new Set<string>();
    this._masterDataService.getCarrierStatesActive(this.selectedLabId, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        stepList = results.data;
        stepList.forEach(type => {
          if (this.selectedProcess && type && type.name && type.process === this.selectedProcess.name) {
            stepFinalList.add(type.stepDisplayName);
            this.workFileProcessStepMap.set(type.stepDisplayName,type.name);
          }
          this.mapOfStepDisplayNameAndProcessStepEntity.set(type.stepDisplayName,type);

        })
        stepFinalList.forEach(step => {
          if (step) {
            this.stepNameOptions.push({label:step.toString(), value:step.toString()});
          }
        })
        this.stepNameOptions.forEach(stepName => {
          if(this.masterList && this.masterList.stepDisplayName && stepName.value == this.masterList.stepDisplayName){
            this.selectedProcessStep = stepName.value;
          }
        })
        if(this.userConfigFlag){
          this.getPlateDetails();
        }else{
          this.initialiseDataSource();
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.workFileDefintionName && this.masterList.constantSubstring
    && this.selectedFileFormat
    && ((this.selectedFileFormat && this.selectedFileFormat.name=="TXT (tab delimited)" && this.selectedMachineType && this.selectedMachineType.name)
         || (this.selectedFileFormat &&
            this.selectedFileFormat.name!="TXT (tab delimited)" && !this.selectedMachineType))
    && this.selectedProcess && this.selectedProcessStep);
  }

  showDialogToAddMasterList(){
    this.masterList = new Workfile;
    this.masterList.continueWithFileConfig=true;
    this.getPreview();
    this.isNewMasterList = true;
    this.displayMasterListDialog = true;
    this.userConfigFlag = true;
    this.selectedLab = null;
    this.masterList.machineType = null;
    this.selectedMachineType = null;
    this.selectedFileFormat=null;
    this.selectedProcessName = null;
    this.selectedProcessStep = null;
    this.selectedProcess = null;
    this.stepNameOptions=[];
    this.tabIndex=0;
    this.initialiseDataSource();
    this.calButtonFlag=false;
    this.calculationList=[];
    this.calculations=[];
    this.errorList=[];
    this.selectedHeaderValue ='yes';
    this.tableDefinitionHeaders =[];
    this.listOfFileDefError=[];
    this.clearReagents()

    this.defaultCalculations("available_amount","sample_concentration","available_volume","PRODUCT");

  }


  private defaultCalculations(sourceName: string ,firstOperand: string , secondOperand: string , operator: string) {
    this.calculationObject = new Calculation();
    this.calculationObject.sourceName = sourceName;
    this.calculationObject.firstOperand = firstOperand;
    this.calculationObject.secondOperand = secondOperand;
    this.calculationObject.operator = this.numericOperator.get(operator);
    this.calculationList.push(this.calculationObject);
    this.calculations.push(this.calculationObject.sourceName + " = " + this.calculationObject.operator + " (" + this.calculationObject.firstOperand + "," + this.calculationObject.secondOperand + ")");
  }
  onRowSelect(event) {
    this.selectedMachineType="";
    this.continueWithMachineOptions = true;
    this.sourcePlatePrefix = false;
    this.targetPlatePrefix  = false;

    this.calButtonFlag = false;
    this.isNewMasterList = false;
    this.tableDefinitionHeaders =[];
    this.listOfFileDefError=[];
    this.validationMap=new Map();
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.selectedFileFormat={label:this.masterList.fileFormat, name:this.masterList.fileFormat};
    this.selectedMachineType={label:this.masterList.machineType, name:this.masterList.machineType};
    this.fileName = this.masterList.fileName;
    this.selectedProcessStep = null;
    this.getProcessList();
    this.getProcessStepList();
    this.reduceToOneRow =this.masterList.reduceToOneRow;
    this.userConfigFlag =this.masterList.continueWithFileConfig;
    if(this.masterList.includeHeader || this.masterList.includeHeader == undefined){
      this.selectedHeaderValue ='yes';
    }else {
      this.selectedHeaderValue ='no';
    }
    this.calculationList=[];
    this.errorList=[];
    this.calculations=[];
    if(this.masterList.calculations && this.masterList.calculations.length>0){
      this.calculationList=[...this.masterList.calculations];
      this.calculationList.forEach(cal => {
        this.calculations.push(cal.sourceName+" = "+cal.operator+" ("+cal.firstOperand+","+cal.secondOperand+")");
      })
    }

    if(this.masterList.plateContentDefinition?.reagents?.length > 0) {
      this.masterList.plateContentDefinition.reagents.forEach(reagent=>{
        this[`reagent${reagent.index}Name`] = reagent.name;
        this[`reagent${reagent.index}Volume`] = reagent.volume;
      })
    } else {
      this.clearReagents()
    }
    this.selectedFileContentDefinition = this.masterList.fileContentDefinitionType
    this.tabIndex=0;
    if(this.masterList.tableDefinition && this.masterList.tableDefinition.length>0){
      this.tableDefinitionHeaders=[...this.masterList.tableDefinition];
    }

    this.tableDefinitionHeaders.forEach(tab => {
      this.validationMap.set(tab.source+tab.category,"1");
    });
    this.disableMachineOptionType();

  }



  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  saveMasterList() {

    if(this.validationFlag) {
      this._messageService.addErrorMessage({ severity: 'Error', summary: 'Duplicate Field', detail: 'Source already exists' });
      return;
    }

    if(this.tabIndex === 2 && this.selectedHeaderValue =='no'){
      if(this.tableDefinitionHeaders.length > 0){
        this.tableDefinitionHeaders.forEach(definition => {
          definition.header =null;
        });
      }
    }
    //in case the list not exists for the first time
    if(!this.masterLists){
      this.masterLists = [];
    }
    if (!this.regexMatcher("^[a-zA-Z0-9_]*$", this.masterList.constantSubstring)) {
      this._messageService.addErrorMessage({
        severity: 'error', summary:'Invalid Constant Substring Pattern!',
        detail:'Constant Substring must contain only 0-9,a-z,A-Z,_'
      });
      return;
    }
    this.validationFOrFileTabDefinition();
    if(this.listOfFileDefError.length == 0){
      this.saveMasterDataIntoDb();
    }
  }
  saveMasterDataIntoDb() {
    var labObj = new LabMDM();
    labObj._id = this.selectedLabId;
    labObj.name = this.selectedLabName;
    this.masterList.lab = labObj;
    this.masterList.fileFormat = this.selectedFileFormat.name;
    if(this.selectedMachineType) {
      this.masterList.machineType = this.selectedMachineType.name;
    }
    this.masterList.processName = this.selectedProcess.name;
    this.masterList.processStepName = this.workFileProcessStepMap.get(this.selectedProcessStep);
    this.masterList.stepDisplayName = this.selectedProcessStep;
    this.masterList.fileName = this.fileName;

    this.masterList.continueWithFileConfig = this.userConfigFlag;
    if (this.calculationList.length > 0 && this.userConfigFlag && this.selectedFileContentDefinition === 'tubes') {
      this.masterList.calculations = this.calculationList;
    }
    if(this.tableDefinitionHeaders.length > 0){
      this.masterList.tableDefinition = this.tableDefinitionHeaders;
    }
    this.masterList.includeHeader=this.selectedHeaderValue == 'yes';
    this.masterList.reduceToOneRow = this.reduceToOneRow;
    if(this.tabIndex === 3) {
      this.masterList.plateContentDefinition.reagents = [];
      for(let index = 1; index <= 3; index++) {
        if(this[`reagent${index}Name`] || this[`reagent${index}Volume`] > 0) {
          this.masterList.plateContentDefinition.reagents.push({name:this[`reagent${index}Name`], volume: this[`reagent${index}Volume`], index: index})
        }
      }
    }

    this.masterList.plateContentDefinition = this.masterList.plateContentDefinition || new PlateContentDefinition();
    if(this.masterList.continueWithFileConfig) {
      this.masterList.fileContentDefinitionType = this.selectedFileContentDefinition;
    }
    var inputData = JSON.stringify(this.masterList);
    this.appendHistory("Workfiles");
    if (this.isNewMasterList) {
      this.saveMasterData(inputData);
    }
    else {
      this.updateMasterData(inputData);
    }
  }

regexMatcher(regex: string, constSubstring: string): boolean {
  let regexp = new RegExp(regex);
  return regexp.test(constSubstring);
}

private handleError(error: any) {
  this.blocked=false;
  let errorMessage = this.errorHandler.handleError(error);
  this._messageService.addErrorMessage(errorMessage);
}

  //Inserts a new Template in DB
  saveMasterData(jsonString: string) {
    let listLength = [];
    this.masterLists.forEach(workfile => {
      if(workfile.workFileDefintionName.trim().toLowerCase() === this.masterList['workFileDefintionName'].trim().toLowerCase()){
        listLength.push(workfile.workFileDefintionName);
      }
    });

    if(listLength.length>0){
      return this._messageService.addErrorMessage({
          severity: 'error', summary:'Duplicate WorkFile Definition Name!',
          detail:'WorkFile Definition Name already present'
        });
    }

    this.blocked=true;
    this._masterDataService.addWorkfileData(jsonString, this.selectedLabId).subscribe(
      flowCellJson=> {
        if (!flowCellJson) {
          return;
        }
        this.displayMasterListDialog = false;
        this.masterList = flowCellJson.data;
        this.masterLists.push(this.masterList);
        this.masterList = null;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Workfile created!', detail: 'New Workfile is created.' });
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );
  }

//Updates a Template in DB
updateMasterData(jsonString: string) {

  this.blocked=true;
    this._masterDataService.updateWorkfile(jsonString, this.selectedLabId, this.selectedMasterList._id).subscribe(
      workFileJson => {
        if (!workFileJson) {
          return;
        }
        this.masterList = workFileJson;
        this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = this.masterList;
        this.masterList = null;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Workfile!', detail: 'Workfile is Updated.' });
        this.displayMasterListDialog = false;
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );


}

getPlateDetails(){
if(this.userConfigFlag){
      let requestObj = {};
      requestObj['labId'] = this.selectedLabId;
      requestObj['processStep'] = this.workFileProcessStepMap.get(this.selectedProcessStep);
      requestObj['process'] = this.selectedProcess.name;
      let sourceplateVals = [];
      let targetplateVals = [];
      this.sourcePlateDef = [];
      this.targetPlateDef  = [];
      this.sourcePlatedataSources =[];
      this.targetPlatedataSources =[];
      this.initialiseDataSource();
      this.selectedFileContentDefinition = this.selectedFileContentDefinition ?? 'tubes'
      this._mdmWorkfileConfigService.getPlateDetailsByProcessStep(requestObj).subscribe(
        plateJson => {
          if (!plateJson.data.data) {
            return;
          }
          sourceplateVals = plateJson.data.data.sourceplateDetails;
          targetplateVals = plateJson.data.data.targetplateDetails;
          this.setSourcePlateOrTargetRequired(this.mapOfStepDisplayNameAndProcessStepEntity.get(this.selectedProcessStep));

          for (let sourcePlate of sourceplateVals) {
            this.sourcePlatedataSources.push(sourcePlate+"_barcode");
            this.sourcePlatedataSources.push(sourcePlate+"_position");
            this.nonNumericSources.set(sourcePlate+"_barcode",sourcePlate+"_barcode");
            this.nonNumericSources.set(sourcePlate+"_position",sourcePlate+"_position");
            this.sourcePlateDef.push({ label: sourcePlate+"_barcode", value: sourcePlate+"_barcode"+"#"+"Source Plate" });
            this.sourcePlateDef.push({ label: sourcePlate+"_position", value: sourcePlate+"_position"+"#"+"Source Plate"});
            this.setSourcePlateWithQuadrantInfo(sourcePlate);
          }
          for (let targetplate of targetplateVals) {
            this.targetPlatedataSources.push(targetplate+"_barcode");
            this.targetPlatedataSources.push(targetplate+"_position");
            this.nonNumericSources.set(targetplate+"_barcode",targetplate+"_barcode");
            this.nonNumericSources.set(targetplate+"_position",targetplate+"_position");
            this.targetPlateDef.push({ label: targetplate+"_barcode", value: targetplate+"_barcode"+"#"+"Target Plate" });
            this.targetPlateDef.push({ label: targetplate+"_position", value: targetplate+"_position"+"#"+"Target Plate" });
            this.setTargetPlateWithQuadrantInfo(targetplate);
          }
          this.sortAllSourceTargetPlate();
        },
        error => {
          this.handleError(error);
          }
      );
    }
}
  private setTargetPlateWithQuadrantInfo(targetplate: any) {
    if (this.targetPlatePrefix) {
      this.targetPlatedataSources.push(targetplate + "_quadrant");
      this.nonNumericSources.set(targetplate + "_quadrant", targetplate + "_quadrant");
      this.targetPlateDef.push({ label: targetplate + "_quadrant", value: `${targetplate}_quadrant#Target Plate` });
    }
  }

  private setSourcePlateWithQuadrantInfo(sourcePlate: any) {
    if (this.sourcePlatePrefix) {
      this.sourcePlatedataSources.push(sourcePlate + "_quadrant");
      this.nonNumericSources.set(sourcePlate + "_quadrant", sourcePlate + "_quadrant");
      this.sourcePlateDef.push({ label: sourcePlate + "_quadrant", value: `${sourcePlate}_quadrant#Source Plate` });        
      

    }
  }

sortAllSourceTargetPlate() {
    this.sourcePlatedataSources.sort((x, y) => {
      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      }
      return 0;
    });
    this.targetPlatedataSources.sort((target1, target2) => {
      if (target1 < target2) {
        return -1;
      } else if (target1 > target2) {
        return 1;
      }
      return 0;
    });
    this.sourcePlateDef.sort((src1, src2) => {
      if (src1.label <src2.label) {
        return -1;
      } else if (src1.label > src2.label) {
        return 1;
      }
      return 0;
    });
    this.targetPlateDef.sort((targ1, targ2) => {
      if (targ1.label < targ2.label) {
        return -1;
      } else if (targ1.label > targ2.label) {
        return 1;
      }
      return 0;
    });
  }

calculationsGroupSet(calculationDef: any[], sourcePlateDef: any[], targetPlateDef: any[]) {
  this.operandSources = [...this.dataSources];
  this.groupedSource=[];
  if (this.calculationList.length <= 0) {
    this.defaultCalculations("available_amount","sample_concentration","available_volume","PRODUCT");
    }
  this.setCalculationDef(calculationDef);

  this.plateGroupedList(sourcePlateDef, targetPlateDef, calculationDef);
}



private setCalculationDef(calculationDef: any[]) {
  this.calculationList.forEach(cal => {
    this.operandSources.push(cal.sourceName);
    calculationDef.push({ label: cal.sourceName, value: cal.sourceName });
  });
}
tabChange(event){
  this.tabIndex = event.index;
  let calculationDef =[];
  this.calculationsGroupSet(calculationDef, this.sourcePlateDef, this.targetPlateDef);
  if(this.tabIndex === 3) {
    this.masterList.plateContentDefinition = this.masterList.plateContentDefinition ?? new PlateContentDefinition();
    this.masterList.plateContentDefinition.treatAsVolumes = this.masterList.plateContentDefinition.treatAsVolumes ?? true;
  }
}

nextTab(){
    if(this.selectedFileContentDefinition === 'tubes') {
      this.tabIndex = this.tabIndex + 1;
    } else {
      this.tabIndex = 3;
    }

  if (this.tabIndex == 1 && this.calculationList.length <= 0) {
      this.defaultCalculations("available_amount","sample_concentration","available_volume","PRODUCT");
  } else if(this.tabIndex === 2){
    let calculationDef =[];
    this.calculationsGroupSet(calculationDef, this.sourcePlateDef, this.targetPlateDef);
  } else if(this.tabIndex === 3) {
    this.masterList.plateContentDefinition = this.masterList.plateContentDefinition ?? new PlateContentDefinition()
    this.masterList.plateContentDefinition.treatAsVolumes = this.masterList.plateContentDefinition.treatAsVolumes ?? true
  }
}

disableSourceTab(){
  return !(this.masterList && this.masterList.workFileDefintionName && this.masterList.constantSubstring && this.selectedFileFormat && this.selectedProcess && this.selectedProcessStep && this.userConfigFlag && this.selectedFileContentDefinition === 'tubes');
}

  disableReagentsAndVolumesTab() {
    return !(this.masterList && this.masterList.workFileDefintionName && this.masterList.constantSubstring && this.selectedFileFormat && this.selectedProcess && this.selectedProcessStep && this.userConfigFlag && this.selectedFileContentDefinition === 'plate');
  }

addCalculation(){

  this.calculationObject  = new Calculation();

  this.operandSources = [];

  this.operandSources = [...this.dataSources];

  if(this.calculationList.length>0){
    this.calculationList.forEach(cal=>{
      this.operandSources.push(cal.sourceName);
    })
  }
  this.calButtonFlag = true;
}

cancelCalculation(){
  this.errorList=[];
  this.calButtonFlag = false;
}

operandSearch(event) {
  let query = event.query;
  this.operandResult = this.operandSources.filter(operand=>operand.toLowerCase().indexOf(query.toLowerCase()) == 0);
}

isSubmitDisabled(){
  return !(this.calculationObject.operator && this.calculationObject.firstOperand && this.calculationObject.secondOperand  && this.calculationObject.sourceName);
}

saveCalculation(){

  this.errorList = [];
  this.sourceNotValidFlag = false;

  if(!this.regexMatcher("^[a-zA-Z0-9_]*$", this.calculationObject.sourceName)){
    this.errorList.push({
      header: 'Source name ', content:"Source name <b>"+ this.calculationObject.sourceName +"</b> contains invalid characters. Only letters (a-z), numbers (0-9) and underscore are allowed."
    });
  }

  this.validateSourceName();

  if(this.dataSources.includes(this.calculationObject.sourceName) || this.sourceNotValidFlag){
    this.errorList.push({
      header: 'Source name ', content:"Source name <b>"+ this.calculationObject.sourceName +"</b> still exists. Choose a non-existing source name."
    });
  }

  this.validateOperand();

  if(this.errorList.length == 0){
    this.calculationList.push(this.calculationObject);
    this.calculations.push(this.calculationObject.sourceName+" = "+this.calculationObject.operator+" ("+this.calculationObject.firstOperand+","+this.calculationObject.secondOperand+")");
    this.calButtonFlag = false;
  }
}

validateSourceName(){

  if(this.calculationList.length>0){
    this.calculationList.forEach(source1 => {
      if(source1.sourceName == this.calculationObject.sourceName){
        this.sourceNotValidFlag = true;
      }
    })
  }
}

validateOperand(){
  if(this.calculationObject.operator == 'CONCAT'){
    this.validateNonNumericOperand();
  }
  else{
    if(Number.isNaN(Number(this.calculationObject.firstOperand))){
      this.validateNumericOperand1();
    }
    else{
      if(!this.regexMatcher("-?d*.?d*", this.calculationObject.firstOperand)){
        this.errorList.push({
          header: 'Operand 1', content:"You have selected arithmetic operator. Operand <b>"+ this.calculationObject.firstOperand +"</b> is not a numeric value."
        });
      }
    }

    if( Number.isNaN(Number(this.calculationObject.secondOperand))){
      this.validateNumericOperand2();
    }
    else{
      if(!this.regexMatcher("-?d*.?d*", this.calculationObject.secondOperand)){
        this.errorList.push({
          header: 'Operand 2', content:"You have selected arithmetic operator. Operand <b>"+ this.calculationObject.secondOperand +"</b> is not a numeric value."
        });
      }
    }
  }
}

validateNumericOperand1(){

  let validFlag1 = false;

if(this.calculationList.length>0){
  this.calculationList.forEach(operand1 => {
    if(operand1.sourceName == this.calculationObject.firstOperand && this.numericOperator.has(operand1.operator)){
      validFlag1 = true;
    }
  });
}

  if(!this.numericSources.has(this.calculationObject.firstOperand) && !validFlag1){
    this.errorList.push({
      header: 'Operand 1', content:"You have selected an arithmetic operator. Operand <b>"+ this.calculationObject.firstOperand +"</b> is not a numeric source."
    });
  }

}

validateNumericOperand2(){

  let validFlag2 = false;

if(this.calculationList.length>0){
  this.calculationList.forEach(operand1 => {
    if(operand1.sourceName == this.calculationObject.secondOperand && this.numericOperator.has(operand1.operator)){
      validFlag2 = true;
    }
  });
}

  if(!this.numericSources.has(this.calculationObject.secondOperand) && !validFlag2){
    this.errorList.push({
      header: 'Operand 2', content:"You have selected an arithmetic operator. Operand <b>"+ this.calculationObject.secondOperand +"</b> is not a numeric source."
    });
  }
}

validateNonNumericOperand(){

  let flags = {validFlag1:false,
    validFlag2:false,
    calfound1:false,
    calfound2:false
  };

this.checkOperandInCalculation(flags);


    if(!this.nonNumericSources.has(this.calculationObject.firstOperand)){
      if(!this.regexMatcher("^[a-zA-Z0-9 _-]*$", this.calculationObject.firstOperand)){
        this.errorList.push({
          header: 'Operand 1', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.firstOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });

      }
      if(this.numericSources.has(this.calculationObject.firstOperand)){
        this.errorList.push({
          header: 'Operand 1', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.firstOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });
      }
    }
    if(!flags.validFlag1 && flags.calfound1){
        this.errorList.push({
          header: 'Operand 1', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.firstOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });
      }

    if(!this.nonNumericSources.has(this.calculationObject.secondOperand)){
      if(!this.regexMatcher("^[a-zA-Z0-9 _-]*$", this.calculationObject.secondOperand)){
        this.errorList.push({
          header: 'Operand 2', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.secondOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });
      }
      if(this.numericSources.has(this.calculationObject.secondOperand)){
        this.errorList.push({
          header: 'Operand 2', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.secondOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });
      }
    }
    if(!flags.validFlag2 && flags.calfound2){
        this.errorList.push({
          header: 'Operand 2', content:"You have selected an non-arithmetic operator. Operand <b>"+ this.calculationObject.secondOperand +"</b> is neither string source nor a valid string. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed."
        });
      }
  }

checkOperandInCalculation(flags){
  if(this.calculationList.length>0){
    this.calculationList.forEach(operand1 => {
      if(operand1.sourceName == this.calculationObject.firstOperand && operand1.operator == 'CONCAT'){
        flags.validFlag1 = true;
      }
      else if(operand1.sourceName == this.calculationObject.firstOperand){
        flags.calfound1 = true;
      }
      if(operand1.sourceName == this.calculationObject.secondOperand && operand1.operator == 'CONCAT'){
        flags.validFlag2 = true;
      }
      else if(operand1.sourceName == this.calculationObject.secondOperand){
        flags.calfound2 = true;
      }
    });
  }
}
plateGroupedList(sourcePlateDef: any[], targetPlateDef: any[],calculationDef :any[]) {
  this.mapOfSourceNamewithCategory=new Map();
  calculationDef.sort((a, b) => {
    if (a.label < b.label) {
      return -1;
    } else if (a.label > b.label) {
      return 1;
    }
    return 0;
  });
  this.groupedSource = [
        {
            label: 'General',
            items: this.groupForSampleLibrary
        }
    ];
    this.groupForSampleLibrary.forEach(object => {
      this.mapOfSourceNamewithCategory.set(object.value, 'General');
    });
  if(sourcePlateDef.length > 0){
    this.groupedSource.push(
      {
          label: 'Source Plate',
          items: sourcePlateDef
      });
      sourcePlateDef.forEach(object => {
        this.mapOfSourceNamewithCategory.set(object.value, 'Source Plate');
      });
  }
  if(targetPlateDef.length > 0){
    this.groupedSource.push(
      {
          label: 'Target Plate',
          items: targetPlateDef
      })
      targetPlateDef.forEach(object => {
        this.mapOfSourceNamewithCategory.set(object.value, 'Target Plate');
      });
  }
  if(calculationDef.length > 0){
    this.groupedSource.push(
      {
          label: 'Calculations',
          items: calculationDef
      })
      calculationDef.forEach(object => {
        this.mapOfSourceNamewithCategory.set(object.value, 'Calculations');
      });
  }
}
addInitialRow() {
  this.listOfFileDefError=[];
  this.tableDefinitionHeaders.push({header:'', source:'',column:1,category:''});
}

deleteRow(workfileDefinition){

  this.validationFlag = false;
  this.validationMap.delete(workfileDefinition.source+workfileDefinition.category);
  let index = this.tableDefinitionHeaders.findIndex(x => x.column === workfileDefinition.column);
  if(index != -1) {
    this.tableDefinitionHeaders.splice(index,1);
  }
}

addRow(workfileDefinition){

  let obj = this.tableDefinitionHeaders[this.tableDefinitionHeaders.length-1];

  this.validationMap.set(obj.source+obj.category,obj.column);
  if(this.validationFlag) {
    this._messageService.addErrorMessage({ severity: 'Error', summary: 'Duplicate Field', detail: 'Source already exists' });
    return;
  }

  this.tableDefinitionHeaders.push({header:'', source:'',column:workfileDefinition.column+1,category:''});
}

validationFOrFileTabDefinition(){
  this.listOfFileDefError =[];
  this.tableDefinitionHeaders.forEach(definition => {
    this.validateTable(definition);
  });
}
validateTable(definition: WorkfileDefinitionHeader) {
  let message='';
  let sourceMessage='';
  let fieldExistence= false;
  let duplicateHeaders = this.selectedHeaderValue == 'yes' ? this.tableDefinitionHeaders.filter((val) => val.header && definition.header && val.header.toLowerCase() === definition.header.trim().toLowerCase()) : [];
    if(this.checkForBothHeaderSource(definition)){
      message ='Please enter both Header and source value. '
      fieldExistence=true;
    }else if(this.checkForSourceAlone(definition)){
      message = 'Please enter source value. ';
      fieldExistence=true;
    }
    ({ message, sourceMessage } = this.checkForInvalidChar(definition, message, duplicateHeaders, fieldExistence, sourceMessage));
    if(message || sourceMessage){
      this.listOfFileDefError.push({
        header: 'Column ' + definition.column, headerError: message,sourceError: sourceMessage});
    }
  }
  checkForInvalidChar(definition: WorkfileDefinitionHeader, message: string, duplicateHeaders: WorkfileDefinitionHeader[], fieldExistence: boolean, sourceMessage: string) {
    let sourceErrorMsg = 'The Source <b>' + definition.source + '</b> contains invalid characters. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed.';
    if (definition.header && this.regexCheckForInvalidCharacter(definition.header)) {
      message = message + 'The Header <b>' + definition.header + '</b> contains invalid characters. For string only letters (a-z), numbers (0-9), underscore, hyphen and whitespaces are allowed' + (duplicateHeaders.length > 1 ? ' and also is not unique.' : '.');
    }
    if (definition.source && this.regexCheckForInvalidCharacter(definition.source)) {
      message = fieldExistence ? (message + sourceErrorMsg) : message;
      sourceMessage = !fieldExistence ? sourceErrorMsg : '';
    }
    if (duplicateHeaders.length > 1 && !this.regexCheckForInvalidCharacter(definition.header)) {
      message = message + 'The Header <b>' + definition.header + '</b> is not unique.';
    }
    return { message, sourceMessage };
  }

  regexCheckForInvalidCharacter(header: any) {
    return !this.regexMatcher("^(?!_)[a-zA-Z0-9_.]*$", header);
  }

checkForSourceAlone(definition: WorkfileDefinitionHeader) {
  return this.selectedHeaderValue == 'no' && !definition.source;
  }

checkForBothHeaderSource(definition: WorkfileDefinitionHeader) {
  return this.selectedHeaderValue == 'yes' && (!definition.header || !definition.source);
  }

getRowOrderIndex(definition: any,index:any){
  definition['column']= index + 1;
    return  definition['column'];
}
  setCategoryNameintoList(workfileDefinition){
    this.validationFlag =false;

    if(workfileDefinition && workfileDefinition.source){

      workfileDefinition.category =

      this.mapOfSourceNamewithCategory.has(workfileDefinition.source)
                                                 ? this.mapOfSourceNamewithCategory.get(workfileDefinition.source) : 'Constants';

      if(workfileDefinition.source.includes("#"))
      {
        workfileDefinition.source = workfileDefinition.source.substring(0,workfileDefinition.source.indexOf("#"));
      }

      if(workfileDefinition.source.indexOf(".") == 0){
        workfileDefinition.source = "0" + workfileDefinition.source;
      }

      if(this.validationMap.has(workfileDefinition.source+workfileDefinition.category)) {
        let col = this.validationMap.get(workfileDefinition.source+workfileDefinition.category);
        if (col!=workfileDefinition.column) {
          this.validationFlag =true;
        }
      }

    }

  }



appendHistory(tabName: string){
  let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
  historyObj.puid = this.puid;
  historyObj.operationDateTime = new Date();
  historyObj.tabName = tabName;
  if(this.masterList.history){
    this.masterList.history.push(historyObj);
  } else {
    this.masterList.history = [];
    this.masterList.history.push(historyObj);
  }
 }

 getCSSClassForPanel(index: number){
  if(index === this.tabIndex){
    return 'selected';
  }else{
    return 'unselected';
  }
}

setSourcePlateOrTargetRequired(type: any) {
  const listOfSpecialHandlingForSourcePlate = Array.of("Split 384 to 96","384-well processing","Tag Assignment 96 to 384");
  const listOfSpecialHandlingForTargetPlate = Array.of("Merge 96 to 384","384-well processing","Tag Assignment 96 to 384");
  type.specialHandlerList.forEach(specialHandling => {
     if (listOfSpecialHandlingForSourcePlate.includes(specialHandling) && (this.masterList.stepDisplayName === type.stepDisplayName || type.stepDisplayName === this.selectedProcessStep) ) {
        this.sourcePlatePrefix = true;
      }
      if(listOfSpecialHandlingForTargetPlate.includes(specialHandling) && (this.masterList.stepDisplayName === type.stepDisplayName || type.stepDisplayName === this.selectedProcessStep) ) {
        this.targetPlatePrefix = true;
      }
  })

}
setCheckboxValue(event: any) {
  this.reduceToOneRow = event.checked;
}

  disableSubmitForDragonFly() {
    return !(this.masterList.plateContentDefinition.version && this.masterList.plateContentDefinition.wellVolume
            && this.reagent1Name && this.reagent1Volume && this.reagent1Volume > 0)
  }

  private clearReagents() {
    this.reagent1Name = null;
    this.reagent1Volume = null;
    this.reagent2Name = null;
    this.reagent2Volume = null;
    this.reagent3Name = null;
    this.reagent3Volume = null;
    this.selectedFileContentDefinition = 'tubes'
  }
}

